import Model from '@/models/Model'

export default class HrIsaprePlan extends Model {
    resource() {
        return 'hr_isapre_plan'
    }
}